import {
  FileOrganizerContext,
  type IFileOrganizerContext,
} from "@via/context/file-organizer-context.tsx";
import { useContext } from "react";

export function useFileOrganizer(): IFileOrganizerContext {
  return useContext(FileOrganizerContext);
}
